import Axios from "./config";

type Pagination = {
	pagination: {
		total: number,
		count: number,
		per_page: number,
		current_page: number,
		total_page: number,
		links: {
			next: string,
			previous: string
		},
	},
};

export type QueryResponse<T> = {
	data: T | null,
	error: string,
}

type PaginatedResponse<T> = QueryResponse<T> & {
	data: T[]
};

// export async function getPaginatedResponse<D>(url: string) {
// 	const response = await getQueryFnWithType<D[]>(url);
//
// 	return response;
// }

// export async function getPaginatedQueryFnWithType<T>(endpoint: string, token: string | null = ""): Promise<PaginatedResponse<T[]>> {
// 	const res = await getQueryFnWithType<T[]>(endpoint, token);
//
// 	return res;
// }
//
const failedError = { error: "Failed to retrieve data.", data: null };

export async function getQueryFnWithType<T extends object>(endpoint: string, token: string | null = ""): Promise<QueryResponse<T>> {
	try {
		const res = await Axios.get<T>(`${endpoint}${token ? `?token=${token}` : ''}`);

		if (res) {
			if ([200, 201].includes(res.status)) {
				return { error: null, data: res.data };
			} else if (res.data && "error" in res.data && res.data.error) {
				return { error: `${res.data.error}`, data: null };
			} else {
				console.error('Potentially invalid response.', res);
			}
		}
	} catch (e) {
		console.error(e);
	}

	return failedError;
}

export async function getQueryFn(endpoint, token = "") /*: Promise<Response<any>>*/ {
	try {
		const res = await Axios.get(`${endpoint}${token ? `?token=${token}` : ''}`);

		if (res.status in [200, 201]) {
			return res.data;
		} else if (res.data && "error" in res.data && res.data.error) {
			return { error: res.data.error, data: null };
		}

		return res.data;
	} catch (err) {
		console.error(err);
	}

	return failedError;
}

export async function postQueryFn(endpoint, data) {
	try {
		const res = await Axios.post(`${endpoint}`, data);

		return res.data;
	} catch (err) {
		console.error(err);
	}

	return failedError;
}

export function queryKeyManager(queryKeys, values) {
	let newQueryKeys = queryKeys;

	values.forEach(value => {
		if (value === undefined || value === null || value === "") return;
		if (!newQueryKeys.includes(value)) {
			newQueryKeys.push(value)
		}
	})

	newQueryKeys = newQueryKeys.filter((element) => {
		return element !== undefined;
	});

	newQueryKeys = newQueryKeys.filter((element) => {
		return element !== "";
	});

	return newQueryKeys;
}